import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index.vue'
import Games from '@/pages/Games.vue'
import Blog from '@/pages/Blog.vue'
import Events from '@/pages/Events.vue'
import About from '@/pages/About.vue'
import Author from '@/pages/Author.vue'
import Article from '@/pages/Article.vue'
import Support from '@/pages/Support.vue'
import Search from '@/pages/Search.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/game',
      name: 'Games',
      component: Games,
      meta: { index: 1, title: '游戏' }
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog,
      meta: { index: 2, title: '博客' }
    },
    {
      path: '/event',
      name: 'Events',
      component: Events,
      meta: { index: 3, title: '事件' }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { index: 4, title: '关于' }
    },
    {
      path: '/author',
      name: 'Author',
      component: Author,
      meta: { index: 5, title: '作者' }
    },
    {
      path: '/game/:id',
      name: 'Article',
      component: Article,
      meta: { index: 1, title: '' }
    },
    {
      path: '*',
      name: 'Index',
      component: Index,
      meta: { index: 0, title: '首页' }
    },
    {
      path: '/s=:id',
      name: 'Search',
      component: Search,
      meta: { index: 9, title: '搜索结果' }
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      meta: { index: 8, title: '赞助支持者列表' }
    }
  ]
})
